<template>
	<div class="personal_center">
		<Header1></Header1>

		<div class="personal_info">
			<div class="lawHeader">当前位置：<span @click="$router.push({path:'index'})">首页 </span>><span>个人中心 </span></div>
			<div class="personalDetail">
				<div class="detailLeft">
					<div class="userInfoCtx">
						<div style="width: 50px;
  height: 50px;
  overflow: hidden;
  justify-content: center;
  align-items: center;
  display: inline-block;
  vertical-align: middle;
  border-radius: 50%;
  margin-left: 20px;">
							<img src="../assets/Img/avator.png" alt="" style="width: 50px;
  height: 50px;">
						</div>
						<div class="userInfo">
							<span>欢迎您:</span>
							<span class="userName">{{loginData.name}}</span>
							<br />
							<span>
								<span class="edit_info" @click="editInfo">修改资料</span>
								<span class="loginout" @click="loginout">退出</span>
							</span>
						</div>
						<div class="personalAction">
							<div class="action1">
								<p>登录</p>
								<p>{{loginData.loginnum}}</p>
							</div>
							<div class="line"></div>
							<div class="action2">
								<p>上传</p>
								<p>{{loginData.uploadnum}}</p>
							</div>
							<div class="line"></div>
							<div class="action3">
								<p>积分</p>
								<p>{{loginData.integral}}</p>
							</div>
						</div>
					</div>
					<div class="tabs">
						<el-menu default-active="1" class="el-menu-vertical-demo" @select="handleSelect">
							<el-menu-item index="1">
								<span><img src="../assets/Img/person/basic.png" width="20"></span>
								<span slot="title" style="margin: 0 7px; height: 15px;width: 20px;line-height: 23px;"> 基础信息</span>
							</el-menu-item>
							<!-- <el-menu-item index="3">
                                <span><img src="../assets/Img/fav.png" width="20"></span>
                                <span slot="title"  style="margin: 0 7px; height: 15px;width: 20px;line-height: 23px;"> 我的收藏</span>
                            </el-menu-item> -->
						</el-menu>
					</div>
					<div class="links">
						<div class="linksTitle">常用链接</div>
						<div class="linkItem">· <a href="http://www.datarural.com/" target="_blank">中国农村数据库</a></div>
						<div class="linkItem">· <a href="http://www.datarural.com/" target="_blank">中国农村数据库个人中心</a>
						</div>
						<div class="linkItem">· <a href="http://www.datarural.com/p/jp/index" target="_blank">家谱库</a>
						</div>
						<div class="linkItem">· <a href="http://www.surveychina.cn/hsnc/index.php/Home/Index/login.html" target="_blank">中国农村村情</a></div>
						<div class="linkItem">· <a href="http://thinktanks.ccnu.edu.cn" target="_blank">村庄调查库</a></div>
					</div>
				</div>
				<div class="detailRight" style=" position: relative;  " v-show="tab==1 & !showDownLoad & !showUpload & !showReviewLoad &!shoucanggengduo">

					<div style=" overflow: hidden;     margin-top: 10px; ">

						<div class="lunbobox clearfix" :style="style" @mousedown='handleTouchStart' @mouseup='handleTouchtouchend'>
							<div class="userActionItem difangzhiUpload" @click="$router.push('/Upload')">
								<span><img src="../assets/Img/personone.png" width="50"></span>
								<span class="userActionText"> 地方志上传 </span>
							</div>

						</div>
					</div>
					<div class="tabbox">
						<div :class="{on:tabs==1}" @click="tabs1(1)">上传/捐赠记录</div>
						<div :class="{on:tabs==2}" @click="tabs1(2)">下载记录</div>
						<div :class="{on:tabs==3}" @click="tabs1(3)">收藏记录</div>

					</div>
					<div v-show="tabs == 1 ">
						<div class="record">

							<div style="" class="upbox" v-for="(item, index) in uploadData">
								<div style=" position: relative;">
									<div style="width: 0;height: 0;border-top: 36px solid #53d13c;border-right: 36px solid transparent;">
										<span style="position: absolute;top: -1px;z-index: 9999;left: 4px;color: #fff;">{{indexMethod(index)}}</span>
									</div>
									<div style=" position:absolute;top:0;left: 11%;    font-size: 16px;overflow: hidden;text-overflow:ellipsis;white-space: nowrap;">
										{{item.uploadername}}<span v-if="item.donation !=2 " style="font-size: 16px;">上传</span>
										<span style=" font-size: 16px;" v-else>捐赠</span>
										<span class="" style=" font-size: 16px;">《{{item.rollname}}》</span>
									</div>
									<div style=" position:absolute;bottom:-28px;left: 12%;    font-size: 16px;">
										<img src="../assets/Img/ku.png" alt="" style="vertical-align: bottom;">
										<span style="font-size: 16px;">地方志</span>

									</div>
									<div style=" position:absolute;bottom:-28px;left: 35%;    font-size: 16px;">
										<img src="../assets/Img/sj.png" alt="" style="vertical-align: bottom;">
										<span>{{item.uploadtime}}</span>
									</div>
									<div style=" position:absolute;bottom:-28px;left: 70%;    font-size: 16px;">
										<img src="../assets/Img/sh.png" alt="" style="vertical-align: bottom;">
										<span v-if="item.auditstatus == 0" style="color:rgba(252, 174, 3, 1);">审核中</span>
										<span v-if="item.auditstatus == 1" style="color:rgba(3, 103, 252, 1)">审核通过</span>
										<span v-if="item.auditstatus == 2" style="color:rgba(252, 3, 3, 1);">审核不通过</span>
									</div>
									<div style=" position:absolute;bottom:-6px;left: 108%;    font-size: 16px;" v-if="item.auditstatus == 1">
										<el-button size="mini" round @click="viewUpload(item)">查看</el-button>
									</div>
								</div>
							</div>

						</div>
					</div>
					<div v-show="tabs == 2 ">
						<div class="record">
							<div style="" class="upbox" v-for="(item, index) in applyData">
								<div style=" position: relative;">
									<div style="width: 0;height: 0;border-top: 36px solid #53d13c;border-right: 36px solid transparent;">
										<span style="position: absolute;top: -1px;z-index: 9999;left: 4px;color: #fff;">{{indexMethod(index)}}</span>
									</div>
									<div style=" position:absolute;top:0;left: 11%;font-size: 16px;overflow:hidden;text-overflow:ellipsis;white-space: nowrap;">
										{{item.downloadername}}
										<span style=" font-size: 16px;">申请下载</span>
										<span class="" style=" font-size: 16px;">《{{item.rollname}}》</span>
									</div>
									<div style=" position:absolute;bottom:-28px;left: 12%;    font-size: 16px;">
										<img src="../assets/Img/ku.png" alt="" style="vertical-align: bottom;">
										<span style="font-size: 16px;">地方志</span>

									</div>
									<div style=" position:absolute;bottom:-28px;left: 35%;    font-size: 16px;">
										<img src="../assets/Img/sj.png" alt="" style="vertical-align: bottom;">
										<span>{{item.downloadertime}}</span>
									</div>
									<div style=" position:absolute;bottom:-28px;left: 70%;    font-size: 16px;">
										<img src="../assets/Img/sh.png" alt="" style="vertical-align: bottom;">
										<span v-if="item.auditstatus == 0" style="color:rgba(252, 174, 3, 1);">审核中</span>
										<span v-if="item.auditstatus == 1" style="color:rgba(3, 103, 252, 1)">审核通过</span>
										<span v-if="item.auditstatus == 2" style="color:rgba(252, 3, 3, 1);">审核不通过</span>
									</div>
									<div style=" position:absolute;bottom:-6px;left: 108%;    font-size: 16px;" v-if="item.auditstatus == 1">
										<el-button size="mini" round @click="details(item)">查看</el-button>
									</div>
								</div>
							</div>
							<!-- <el-row class="item" v-for="(item, index) in applyData" v-if="index < 5" >
                            <el-col :span="2">
                                <div class="downImg">
                                    <img src="../assets/Img/apply.png" width="30" alt="">
                                </div>
                            </el-col>
                            <el-col :span="18">
                              <div>
                                <span style="color:red" v-if="item.bptype == 1">书库</span>
                                <span style="color:red" v-else-if="item.bptype == 2">文库</span>
                                <span style="color:red" v-else-if="item.bptype == 3">政策库</span>
                                <span style="color:red" v-else-if="item.bptype == 4">马恩库</span>
                                <span style="color:red" v-else-if="item.bptype == 5">思想谱系库</span>
                                <span style="color:red" v-else-if="item.bptype == 6">动态库</span>
                                <span style="color:red" v-else-if="item.bptype == 7">动态库</span>

                              </div>
                                <div style="padding-top: 5px">
                                    <div> {{item.downloadername}} {{item.downloadertime}}</div>
                                    <div> 申请下载 <span class="highlight" @click="goinfo(item)">{{item.bpname}}</span></div>
                                </div>
                            </el-col>
                            <el-col :span="4">
                                <div style="padding-top: 8px"></div>
                                <el-button @click="viewDownload(item)" size="mini" round>查看</el-button>
                            </el-col>
                        </el-row> -->
						</div>
					</div>
					<div v-show="tabs == 3 ">

						<div class="record">
							<div style="" class="upbox" v-for="(item, index) in collectionList">
								<div style=" position: relative;">
									<div style="width: 0;height: 0;border-top: 36px solid #53d13c;border-right: 36px solid transparent;">
										<span style="position: absolute;top: -1px;z-index: 9999;left: 4px;color: #fff;">{{indexMethod(index)}}</span>
									</div>
									<div style=" position:absolute;top:0;left: 11%;font-size: 16px;overflow:hidden;text-overflow:ellipsis;white-space: nowrap;">
										{{item.username}}
										<span style=" font-size: 16px;">收藏了</span>
										<span class="" style=" font-size: 16px;">《{{item.rollname}}》</span>
									</div>
									<div style=" position:absolute;bottom:-28px;left: 12%;    font-size: 16px;">
										<img src="../assets/Img/ku.png" alt="" style="vertical-align: bottom;">
										<span style="font-size: 16px;">地方志</span>

									</div>
									<div style=" position:absolute;bottom:-28px;left: 35%;    font-size: 16px;">
										<img src="../assets/Img/sj.png" alt="" style="vertical-align: bottom;">
										<span>{{item.collectdate}}</span>
									</div>

									<div style=" position:absolute;bottom:-6px;left: 108%;    font-size: 16px;">
										<el-button size="mini" round @click="details(item)">查看</el-button>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div style="display: flex;justify-content: center;">
						<el-pagination @current-change="fenye" @size-change="handleSizeChange" :current-page="page.offset" :page-size="page.limit"
						 :page-sizes="[10, 20, 50]" layout="total, sizes, prev, pager, next, jumper" :total="count">
						</el-pagination>
					</div>

				</div>
				<UploadRecord v-if="showUpload">
					<span v-show="showUpload" @click="showUpload = false" class="back">返回</span>
				</UploadRecord>
				<DownloadRecord v-if="showDownLoad">
					<span v-show="showDownLoad" @click="showDownLoad = false" class="back">返回</span>
				</DownloadRecord>

				<div class="detailRight" v-show="tab==3">
					奥术大师大
				</div>
				<div class="detailRight" v-show="tab==4">
					<div class="RegisterItem" style="margin-top: 10%">
						<label class="RegisterLabel">用户名：</label>
						<input style="background-color: #e9e9eb" class="RegisterInput" readonly type="text" v-model="register.username" />
					</div>
					<div class="RegisterItem">
						<label class="RegisterLabel">真实姓名：</label>
						<input class="RegisterInput" type="text" v-model="register.realName" />
					</div>
					<div class="RegisterItem">
						<label class="RegisterLabel">手机号：</label>
						<input class="RegisterInput" style="background-color: #e9e9eb" readonly type="text" v-model="register.phone" />
					</div>
					<div class="RegisterItem">
						<label class="RegisterLabel">保密邮箱：</label>
						<input class="RegisterInput" style="background-color: #e9e9eb" readonly type="text" v-model="register.email" />
					</div>
					<div class="RegisterItem">
						<label class="RegisterLabel">出生年月：</label>
						<el-date-picker style="width:50%;" size="small" format="yyyy-MM-dd" value-format="yyyy-MM-dd" v-model="register.birth"
						 type="date"></el-date-picker>
					</div>
					<div class="RegisterItem">
						<div class="divwrap" style="width: 520px">
							<label class="RegisterLabel">所在地区：</label>
							<!--<input v-if="region == 1"  class="RegisterInput" type="text" v-model="liveAddress" style="width: 48%"/>-->
							<!--<div v-if="region == 1" class="btn" style="cursor: pointer" @click="regionClick">修改</div>-->
							<div class="divwrap" style="display: inline-block">
								<el-select size="mini" style="width: 85px" value-key="areacode" v-model="provinceitem" @change="loadCity">
									<el-option v-for="pitem in proviceList" :key="pitem.areacode" :value="pitem" :label="pitem.nickname"></el-option>
								</el-select>
								<el-select size="mini" style="width: 115px" v-model="cityitem" value-key="areacode" @change="loadArea">
									<el-option v-for="citem in cityList" :key="citem.areacode" :value="citem" :label="citem.nickname"></el-option>
								</el-select>
								<el-select size="mini" style="width: 115px" value-key="areacode" v-model="areaitem" @change="selectArea">
									<el-option v-for="aitem in areaList" :key="aitem.areacode" :value="aitem" :label="aitem.nickname"></el-option>
								</el-select>
							</div>
						</div>
					</div>
					<div class="RegisterItem">
						<label class="RegisterLabel">最高学历：</label>
						<input v-if="Education == 1" class="RegisterInput" type="text" v-model="register.education" style="width: 48%" />
						<div v-if="Education == 1" class="btn" style="cursor: pointer" @click="EducationClick">修改</div>
						<div class="divwrap" v-if="Education == 2" style="display: inline-block">
							<select v-model="register.education" style="color: #7b7b7b; font-size: 12px;height: 30px;margin: -23px 0;display: block">
								<option :value="temp.name" v-for="temp in educationList">{{temp.name}}</option>
							</select>
						</div>
					</div>
					<div class="RegisterItem">
						<label class="RegisterLabel">行业：</label>
						<input v-if="industry == 1" class="RegisterInput" type="text" v-model="register.works" style="width: 48%" />
						<div v-if="industry == 1" class="btn" style="cursor: pointer" @click="industryClick">修改</div>
						<div v-if="industry == 2" class="divwrap" style="display: inline-block">
							<el-cascader expand-trigger="hover" :options="options" v-model="selectedOptions2" @change="selectJobs" size="mini"></el-cascader>
						</div>
					</div>
					<div class="RegisterItem">
						<label class="RegisterLabel">所在单位：</label>
						<input class="RegisterInput" type="text" v-model="register.department" />
					</div>
					<div class="RegisterBtn" style="cursor: pointer;" @click="onSubmit">提交</div>
				</div>
			</div>
		</div>
		<Foot></Foot>
	</div>
</template>

<script>
	import Header1 from '../components/Header1.vue';
	import Foot from '../components/Foot.vue';
	import {
		request
	} from '../API/ApiUrl';
	import DownloadRecord from './DownloadRecord';
	import UploadRecord from './UploadRecord';
	// import shoucanggengduo from './shoucanggengduo'
	import {
		Message
	} from 'element-ui';
	import AES from "../assets/aes.js";
	export default {
		components: {
			Header1,
			Foot,
			DownloadRecord,
			UploadRecord,
			// shoucanggengduo
		},
		data() {
			return {
				tabs: 1,
				count: 0,
				industry: '1',
				// region:'1',
				Education: '1',
				uploadData: [],
				applyData: [],
				auditstatuss: {
					0: '待审核',
					1: '审核通过',
					2: '审核不通过'
				},
				score: 0,
				tab: 1,
				detail: {},
				dialogTableVisible: false,
				loginData: JSON.parse(sessionStorage.loginData),
				collectionList: [],
				messageList: [],
				page: {
					limit: 10,
					offset: 1
				},
				showDownLoad: false,
				shoucanggengduo: false,
				showUpload: false,
				showReviewLoad: false,
				downloadDetail: {},
				downloadVisible: false,
				register: {
					username: "",
					// liveAddress:"",
					realName: '', //真实姓名
					email: '', //邮箱
					name: '', //昵称
					phone: '', //手机
					birth: '', //生日
					validateCode: '', //验证码
					education: '', //教育程度
					investigator: '',
					province: '', //省份
					city: '', //城市
					area: '', //地区
					works: '', //职业
					department: '' // 所在单位
				},
				proviceList: [], //存省份的数组
				cityList: [],
				areaList: [],
				provinceitem: {
					areacode: '',
					nickname: ''
				},
				cityitem: {
					areacode: '',
					nickname: ''
				},
				areaitem: {
					areacode: '',
					nickname: ''
				},
				educationList: [{
						id: '1',
						name: '博士后'
					},
					{
						id: '2',
						name: '博士'
					},
					{
						id: '3',
						name: '硕士'
					},
					{
						id: '4',
						name: '本科'
					},
					{
						id: '5',
						name: '大专'
					},
					{
						id: '6',
						name: '中专'
					},
					{
						id: '7',
						name: '高中及以下'
					}
				],
				options: [{
						"value": "学生",
						"label": "学生",
						"children": [{
							"value": "学生",
							"label": "学生",
						}]
					},
					{
						"value": "科学研究和技术服务业",
						"label": "科学研究和技术服务业",
						"children": [{
								"value": "研究和试验发展",
								"label": "研究和试验发展"
							},
							{
								"value": "专业技术服务业 ",
								"label": "专业技术服务业 "
							},
							{
								"value": "科技推广和应用服务业",
								"label": "科技推广和应用服务业 "
							}
						]
					},
					{
						"value": "教育",
						"label": "教育",
						"children": [{
							"value": "教育",
							"label": "教育 "
						}]
					},
					{
						"value": "公共管理、社会保障和社会组织",
						"label": "公共管理、社会保障和社会组织",
						"children": [{
								"value": "中国共产党机关",
								"label": "中国共产党机关"
							},
							{
								"value": "国家机构",
								"label": "国家机构"
							},
							{
								"value": "人民政协、民主党派",
								"label": "人民政协、民主党派"
							},
							{
								"value": "社会保障",
								"label": "社会保障"
							},
							{
								"value": "群众团体、社会团体和其他成员组织",
								"label": "群众团体、社会团体和其他成员组织"
							},
							{
								"value": "基层群众自治组织",
								"label": "基层群众自治组织"
							}
						]
					},
					{
						"value": "文化、体育和娱乐业",
						"label": "文化、体育和娱乐业",
						"children": [{
								"value": "新闻和出版业",
								"label": "新闻和出版业"
							},
							{
								"value": "广播、电视、电影和录音制作业",
								"label": "广播、电视、电影和录音制作业"
							},
							{
								"value": "文化艺术业",
								"label": "文化艺术业"
							},
							{
								"value": "体育",
								"label": "体育"
							},
							{
								"value": "娱乐业",
								"label": "娱乐业"
							}
						]
					},
					{
						"value": "卫生和社会工作",
						"label": "卫生和社会工作",
						"children": [{
								"value": "卫生",
								"label": "卫生"
							},
							{
								"value": "社会工作",
								"label": "社会工作"
							}
						]
					},
					{
						"value": "信息传输、软件和信息技术服务业",
						"label": "信息传输、软件和信息技术服务业",
						"children": [{
								"value": "电信、广播电视和卫星传输服务",
								"label": "电信、广播电视和卫星传输服务"
							},
							{
								"value": "互联网和相关服务",
								"label": "互联网和相关服务"
							},
							{
								"value": "软件和信息技术服务业 ",
								"label": "软件和信息技术服务业 "
							}
						]
					},
					{
						"value": "水利、环境和公共设施管理业",
						"label": "水利、环境和公共设施管理业",
						"children": [{
								"value": "水利管理业 ",
								"label": "水利管理业 "
							},
							{
								"value": "生态保护和环境治理业",
								"label": "生态保护和环境治理业 "
							},
							{
								"value": "公共设施管理业",
								"label": "公共设施管理业 "
							},
							{
								"value": "土地管理业",
								"label": "土地管理业 "
							}
						]
					},
					{
						"value": "居民服务、修理和其他服务业",
						"label": "居民服务、修理和其他服务业",
						"children": [{
								"value": "居民服务业",
								"label": "居民服务业 "
							},
							{
								"value": "机动车、电子产品和日用产品修理业",
								"label": "机动车、电子产品和日用产品修理业 "
							},
							{
								"value": "其他服务业 ",
								"label": "其他服务业  "
							}
						]
					},
					{
						"value": "农、林、牧、渔业",
						"label": "农、林、牧、渔业",
						"children": [{
								"value": "农业",
								"label": "农业"
							},
							{
								"value": "林业",
								"label": "林业"
							},
							{
								"value": "畜牧业",
								"label": "畜牧业"
							},
							{
								"value": "渔业",
								"label": "渔业"
							},
							{
								"value": "农、林、牧、渔专业及辅助性活动",
								"label": "农、林、牧、渔专业及辅助性活动"
							}
						]
					},
					{
						"value": "电力、热力、燃气及水生产和供应业",
						"label": "电力、热力、燃气及水生产和供应业",
						"children": [{
								"value": "电力、热力生产和供应业",
								"label": "电力、热力生产和供应业"
							},
							{
								"value": "燃气生产和供应业",
								"label": "燃气生产和供应业"
							},
							{
								"value": "水的生产和供应业 ",
								"label": "水的生产和供应业 "
							}
						]
					},
					{
						"value": "金融业",
						"label": "金融业",
						"children": [{
								"value": "货币金融服务",
								"label": "货币金融服务"
							},
							{
								"value": "资本市场服务",
								"label": "资本市场服务"
							},
							{
								"value": "保险业",
								"label": "保险业 "
							},
							{
								"value": "其他金融业",
								"label": "其他金融业 "
							}
						]
					},
					{
						"value": "房地产业",
						"label": "房地产业",
						"children": [{
							"value": "房地产业 ",
							"label": "房地产业 "
						}]
					},
					{
						"value": "租赁和商务服务业",
						"label": "租赁和商务服务业",
						"children": [{
								"value": "租赁业 ",
								"label": "租赁业 "
							},
							{
								"value": "商务服务业 ",
								"label": "商务服务业 "
							}
						]
					},
					{
						"value": "国际组织",
						"label": "国际组织",
						"children": [{
							"value": "国际组织",
							"label": "国际组织"
						}]
					},
					{
						"value": "建筑业",
						"label": "建筑业",
						"children": [{
								"value": "房屋建筑业",
								"label": "房屋建筑业"
							},
							{
								"value": "土木工程建筑业",
								"label": "土木工程建筑业"
							},
							{
								"value": "建筑安装业 ",
								"label": "建筑安装业 "
							},
							{
								"value": "建筑装饰、装修和其他建筑业 ",
								"label": "建筑装饰、装修和其他建筑业 "
							}
						]
					},
					{
						"value": "批发和零售业",
						"label": "批发和零售业",
						"children": [{
								"value": "批发业",
								"label": "批发业"
							},
							{
								"value": "零售业",
								"label": "零售业"
							}
						]
					},
					{
						"value": "住宿和餐饮业",
						"label": "住宿和餐饮业",
						"children": [{
								"value": "住宿业",
								"label": "住宿业"
							},
							{
								"value": "餐饮业",
								"label": "餐饮业"
							}
						]
					},
					{
						"value": "交通运输、仓储和邮政业",
						"label": "交通运输、仓储和邮政业",
						"children": [{
								"value": "铁路运输业",
								"label": "铁路运输业"
							},
							{
								"value": "道路运输业",
								"label": "道路运输业"
							},
							{
								"value": "水上运输业 ",
								"label": "水上运输业 "
							},
							{
								"value": "航空运输业",
								"label": "航空运输业"
							},
							{
								"value": "管道运输业",
								"label": "管道运输业"
							},
							{
								"value": "多式联运和运输代理业",
								"label": "多式联运和运输代理业"
							},
							{
								"value": "装卸搬运和仓储业",
								"label": "装卸搬运和仓储业"
							},
							{
								"value": "邮政业",
								"label": "邮政业"
							}
						]
					},
					{
						"value": "采矿业",
						"label": "采矿业",
						"children": [{
								"value": "煤炭开采和洗选业",
								"label": "煤炭开采和洗选业"
							},
							{
								"value": "石油和天然气开采业",
								"label": "石油和天然气开采业"
							},
							{
								"value": "黑色金属矿采选业",
								"label": "黑色金属矿采选业"
							},
							{
								"value": "有色金属矿采选业",
								"label": "有色金属矿采选业"
							},
							{
								"value": "非金属矿采选业",
								"label": "非金属矿采选业"
							},
							{
								"value": "开采专业及辅助性活动",
								"label": "开采专业及辅助性活动"
							},
							{
								"value": "其他采矿业",
								"label": "其他采矿业"
							}
						]
					},
					{
						"value": "制造业",
						"label": "制造业",
						"children": [{
								"value": "农副食品加工业",
								"label": "农副食品加工业"
							},
							{
								"value": "食品制造业",
								"label": "食品制造业"
							},
							{
								"value": "酒、饮料和精制茶制造业",
								"label": "酒、饮料和精制茶制造业"
							},
							{
								"value": "烟草制品业",
								"label": "烟草制品业"
							},
							{
								"value": "纺织业",
								"label": "纺织业"
							},
							{
								"value": "纺织服装、服饰业",
								"label": "纺织服装、服饰业"
							},
							{
								"value": "皮革、毛皮、羽毛及其制品和制鞋业",
								"label": "皮革、毛皮、羽毛及其制品和制鞋业"
							},
							{
								"value": "木材加工和木、竹、藤、棕、草制品业",
								"label": "木材加工和木、竹、藤、棕、草制品业"
							},
							{
								"value": "家具制造业",
								"label": "家具制造业"
							},
							{
								"value": "造纸和纸制品业",
								"label": "造纸和纸制品业"
							},
							{
								"value": "印刷和记录媒介复制业",
								"label": "印刷和记录媒介复制业"
							},
							{
								"value": "文教、工美、体育和娱乐用品制造业",
								"label": "文教、工美、体育和娱乐用品制造业"
							},
							{
								"value": "石油、煤炭及其他燃料加工业",
								"label": "石油、煤炭及其他燃料加工业"
							},
							{
								"value": "化学原料和化学制品制造业",
								"label": "化学原料和化学制品制造业"
							},
							{
								"value": "医药制造业",
								"label": "医药制造业"
							},
							{
								"value": "化学纤维制造业",
								"label": "化学纤维制造业"
							},
							{
								"value": "橡胶和塑料制品业",
								"label": "橡胶和塑料制品业"
							},
							{
								"value": "非金属矿物制品业",
								"label": "非金属矿物制品业"
							},
							{
								"value": "黑色金属冶炼和压延加工业",
								"label": "黑色金属冶炼和压延加工业"
							},
							{
								"value": "有色金属冶炼和压延加工业",
								"label": "有色金属冶炼和压延加工业"
							},
							{
								"value": "金属制品业",
								"label": "金属制品业"
							},
							{
								"value": "通用设备制造业",
								"label": "通用设备制造业"
							},
							{
								"value": "专用设备制造业",
								"label": "专用设备制造业"
							},
							{
								"value": "汽车制造业",
								"label": "汽车制造业"
							},
							{
								"value": "铁路、船舶、航空航天和其他运输设备制造业",
								"label": "铁路、船舶、航空航天和其他运输设备制造业"
							},
							{
								"value": "电气机械和器材制造业",
								"label": "电气机械和器材制造业"
							},
							{
								"value": "计算机、通信和其他电子设备制造业",
								"label": "计算机、通信和其他电子设备制造业"
							},
							{
								"value": "仪器仪表制造业",
								"label": "仪器仪表制造业"
							},
							{
								"value": "其他制造业",
								"label": "其他制造业"
							},
							{
								"value": "废弃资源综合利用业",
								"label": "废弃资源综合利用业"
							},
							{
								"value": "金属制品、机械和设备修理业",
								"label": "金属制品、机械和设备修理业"
							}
						]
					}
				],
				selectedOptions2: [], //行业
				userData: "",
				startX: '',
				endX: '',
				moveX: '',
				style: `transform: translateX(0px);`
			}
		},
		watch: {
			tab: function(val) {
				if (val !== 1) {
					this.showDownLoad = false;
					this.showUpload = false;
					this.showReviewLoad = false
				}
			}
		},
		mounted() {

			// this.getCollectList();
			this.getUploadRecord();
			// this.getApplyRecord();
			this.getUserInfo();
			this.loadProvice();
			this.userInfo()
			this.addVisit();

		},
		methods: {
			indexMethod(index) {
				return index + 1 + (this.page.offset - 1) * this.page.limit;
			},
			tabs1(val) {
				this.tabs = val;
				this.page.limit = 10
				this.page.offset = 1
				if (val == 2) {
					this.getApplyRecord();

				} else if (val == 3) {
					this.getCollectList();

				} else if (val == 1) {
					this.getUploadRecord();

				}
			},
			fenye(val) {
				this.page.offset = val
				if (this.tabs == 1) {
					this.getUploadRecord()
				} else if (this.tabs == 2) {
					this.getApplyRecord()
				} else {
					this.getCollectList()
				}
			},
			handleSizeChange(val) {
				this.page.limit = val
				if (this.tabs == 1) {
					this.getUploadRecord()
				} else if (this.tabs == 2) {
					this.getApplyRecord()
				} else {
					this.getCollectList()
				}

			},
			goinfo(val) {
				//console.log(val)
				this.$router.push({
					path: '/Detail',
					query: {
						userId: this.userData.userId,
						rollid: item.rollid
					}
				})

			},
			handleTouchStart(event) {
				//console.log(event)

				this.startX = event.clientX
				//console.log(this.startX, '坐标')
			},

			handleTouchtouchend(event) {
				this.endX = event.clientX

				//console.log(this.endX, '结束坐标', this.endX - this.startX)
				this.moveX = this.endX - this.startX
				if (this.moveX < 0) {
					this.style = `transform: translateX(-514px);`

				} else {
					this.style = `transform: translateX(0px);`

				}

			},
			left() {
				this.style = `transform: translateX(0px);`
			},
			right() {
				this.style = `transform: translateX(-514px);`
			},

			//增加点击量
			addVisit() {
				request('/apiVisit/addVisitData', {
					"module": 108
				}).then(res => {

				})
			},
			//获取回显信息
			userInfo() {
				var keys = AES.generatekey(16);
				
				var encrypts = AES.encrypt(JSON.stringify(this.loginData.userId), keys);
				
				request('/api/UserInfo', {
					userId: encrypts,
					key:keys,
					passflag: -1
				}).then(res => {
					if (res.code === 200) {
						this.userData = res.data.user;
						this.register.email = this.userData.email;
						this.register.phone = this.userData.mobile;
						this.register.username = this.userData.username;
						this.register.realName = this.userData.name;
						this.register.birth = this.userData.birth;
						this.register.education = this.userData.education;
						this.provinceitem = this.userData.province;
						this.cityitem = this.userData.city;
						this.areaitem = this.userData.district;
						this.register.works = this.userData.works;
						this.register.department = this.userData.department;
					} else {
						this.$message({
							message: res.msg,
							type: 'error'
						})
					}
				})
			},
			//提交
			onSubmit() {
				if (this.register.realName == "") {
					Message.warning('请填写真实姓名');
					return false
				}
				if (this.register.birth == "") {
					Message.warning('请填写出生年月日');
					return false
				}
				if (this.register.education == "") {
					Message.warning('请选择最高学历');
					return false
				}
				if (this.register.works == "") {
					Message.warning('请选择行业');
					return false
				}
				if (this.register.department == "") {
					Message.warning("请填写工作单位");
					return false
				}
				request('/api/editUserInfo', {
					userId: this.loginData.userId,
					realName: this.register.realName,
					// email:this.register.email,
					birth: this.register.birth,
					works: this.register.works,
					education: this.register.education,
					department: this.register.department,
					province: this.provinceitem.nickname,
					city: this.cityitem.nickname,
					district: this.areaitem.nickname,
					passflag: -1
				}).then(res => {
					if (res.code === 200) {
						Message.success('修改成功');
						this.tab = 1;
					} else {
						this.$message({
							message: res.msg,
							type: 'error'
						})
					}
				})

			},
			industryClick() {
				this.industry = '2'
			},
			EducationClick() {
				this.Education = '2'
			},
			editInfo() {
				this.tab = '4'
			},
			selectJobs(label) {
				this.register.works = label[1].toString()
			},

			loadProvice() {
				request('/apiBaseFile/getAreaInfo', {
					areaLevel: 1,
					parentCode: ''
				}).then(res => {
					if (res.code === 200) {
						this.proviceList = res.data.areaList
					} else {
						this.$message.error(res.msg)
					}
				})

			},
			loadCity() {
				this.register.province = this.provinceitem.nickname
				request('/apiBaseFile/getAreaInfo', {
					parentCode: this.provinceitem.areacode,
					areaLevel: 2
				}).then(res => {
					if (res.code === 200) {
						this.cityList = res.data.areaList
					} else {
						Message(res.data.msg)
					}
				})

			},
			loadArea() {
				this.register.city = this.cityitem.nickname
				// 刷新图表数据
				request('/apiBaseFile/getAreaInfo', {
					parentCode: this.cityitem.areacode,
					areaLevel: 3
				}).then(res => {
					if (res.code === 200) {
						this.areaList = res.data.areaList
					} else {
						this.$message.error(res.data.msg)
					}
				})
			},
			selectArea() {
				this.register.area = this.areaitem.nickname
			},
			//收藏和下载查看详情
			details(item) {
				//console.log(item.rollname)
				request('/apidfz/localHistoryBookList', {
					offset: 1,
					limit: 10,
					searchName: item.rollname,
					searchType: 'buxian',
					yearSort: 0,
					publishyearSort: 0,
					arealevel: '',
					year: '',
					province: '',
					lctype: 2,
					rolltype: '',
					datetype: 1,
					passflag: -1
				}).then(res => {
					if (res.code == 200) {
						this.$router.push('/DiFangZhiNeiRong1?id=' + res.data.dfzlist[0].volumeid + '&isroll=' + 2 + "&vid=" + res.data
							.dfzlist[0].id)

					}
				})

			},

			loginout() {
				this.loginData = '';
				sessionStorage.clear();
				this.$router.push("/login?type=1");
			},
			homePage() {
				this.$router.push("/index");
			},

			// 每次进来获取用户的积分合各个指标的项
			getUserInfo() {
				
				var keys = AES.generatekey(16);
				var encrypts = AES.encrypt(JSON.stringify(this.loginData.userId), keys);
				
				if (this.loginData.userId != 0) {
					request('/api/getUserInfo', {
						userId: encrypts,
						keys : keys,
						passflag: -1
					}).then((res) => {
						if (res.code === 200) {
							this.loginData.loginnum = res.data.loginnum
							this.loginData.uploadnum = res.data.uploadnum
							this.loginData.integral = res.data.integral
							this.loginData.isHaveAuth = res.data.isHaveAuth
						} else {
							this.$message({
								message: res.msg,
								type: 'error'
							})
						}
					})
				}

			},
			// 获取收藏列表
			getCollectList() {
				request('/apidfz/localHistoryCollectByUserid', {
					userid: this.loginData.userId,
					offset: this.page.offset,
					limit: this.page.limit,
					passflag: -1
				}).then((res) => {
					if (res.code === 200) {
						this.collectionList = res.data
						this.count = res.count
					} else {
						this.$message({
							message: res.msg,
							type: 'error'
						})
					}
				})
			},
			// 获取上传记录
			getUploadRecord() {
				request('/apidfz/listLcUploadApply', {
					userid: this.loginData.userId,
					limit: this.page.limit,
					offset: this.page.offset,
					passflag: -1
				}).then(res => {
					if (res.code === 200) {
						this.uploadData = res.data
						this.count = res.count
					} else {
						this.$message({
							message: res.msg,
							type: 'error'
						})
					}
				})
			},
			//申请记录、审核记录
			getApplyRecord() {
				request('/apidfz/listLcDownloadApply', {
					userid: this.loginData.userId,
					limit: this.page.limit,
					offset: this.page.offset,
					passflag: -1
				}).then(res => {
					if (res.code === 200) {
						// //console.log(res)
						// //console.log(11111)
						this.applyData = res.data
						this.count = res.count
					} else {
						this.$message({
							message: res.msg,
							type: 'error'
						})
					}
				})
			},
			handleSelect(index, indexPath) {
				this.tab = index
			},
			back() {
				this.showDownLoad = false
				this.showUpload = false
				showReviewLoad: false
			},
			// 查看上传记录
			viewUpload(item) {
				//       id: this.$route.query.id,
				// isroll: this.$route.query.isroll,
				// vid: this.$route.query.vid,
				//console.log(item);
				request('/apidfz/localHistoryBookList', {
					offset: 1,
					limit: 10,
					searchName: item.rollname,
					searchType: 'buxian',
					yearSort: 0,
					publishyearSort: 0,
					arealevel: '',
					year: '',
					province: '',
					lctype: 2,
					rolltype: '',
					datetype: 1,
					passflag: -1
				}).then(res => {
					if (res.code == 200) {
						this.$router.push('/DiFangZhiNeiRong1?id=' + res.data.dfzlist[0].volumeid + '&isroll=' + 2 + "&vid=" + res.data
							.dfzlist[0].id)
						// this.$router.push({ path: '/Detail', query: { userId: this.userData.userId, rollid: res.data.YbRollList[0].id } })
					}
				})
			},
			getUploadDetail(uploadId) {
				request('/apidfz/uploadDetail', {
					userid: this.loginData.userId,
					type: 2,
					uploadId: uploadId,
					passflag: -1
				}).then(res => {
					if (res.code === 200) {
						//console.log(res)
						this.detail = res.data.detail;
						// this.dialogTableVisible = true;
					} else {
						this.$message({
							message: res.msg,
							type: 'error'
						})
					}
				})
			},
			// 查看申请记录
			viewDownload(item) {
				this.downloadDetail = item;
				this.downloadVisible = true;
			},

		}
	}
</script>
<style scpoed>
	.upbox {
		margin-bottom: 25px;
		/* width: 100%; */
		padding: 12px 140px 40px 8px;
		color: #505050;
		background-color: #fff;
		border-radius: 12px;
		font-size: 14px;
		line-height: 150%;
		border: 1px solid #e7e7e7;
		-webkit-box-shadow: inset 0 -3px 3px 0 rgba(0, 0, 0, 0.12142857);
		box-shadow: inset 0 -3px 3px 0 rgba(0, 0, 0, 0.12142857);
		cursor: pointer;
	}

	.upbox:hover {
		border-color: #91d8e1;
	}

	.tabbox .on {
		border-bottom: 2px solid blue;
	}

	.tabbox {
		display: flex;
		border-bottom: 2px solid #ccc;
		justify-content: center;
		margin-top: 15px;
	}

	.tabbox>div {
		font-size: 16px;
		font-weight: 600;
		height: 35px;
		text-align: center;
		padding: 0 30px;
		cursor: pointer;
	}

	.lawHeader {
		text-align: left;
		box-sizing: border-box;
		font-size: 14px;
		padding-bottom: 15px;
		padding-top: 15px;
		margin: auto;
		margin-top: 10px;
		border-bottom: 1px solid #e2ece8;
	}

	.btn {
		height: 30px;
		width: 60px;
		margin: 4px 10px;
		background: #409eff;
		color: #f1f1f2;
		font-size: 13px;
		line-height: 30px;
		text-align: center;
		border-radius: 5px;
		border: none;
		display: inline-block;
	}

	.btn:hover {
		background: #408ce1;
		color: #f1f1f2;
	}

	.RegisterItem {
		font-size: 14px;
		width: 520px;
		margin: 10px auto;
	}

	.RegisterLabel {
		color: #077882;
		width: 27%;
		display: inline-block;
		text-align: right;
	}

	.RegisterInput {
		width: 60%;
		border: 1px solid #dcd9d9;
		border-radius: 5px;
		height: 30px;
		padding-left: 10px;
	}

	.RegisterBtn {
		height: 30px;
		width: 60px;
		margin: 11px auto;
		background: #2371c7;
		color: #f1f1f2;
		font-size: 13px;
		line-height: 30px;
		text-align: center;
		border-radius: 4px;
	}

	.RegisterBtn:hover {
		background: #408ce1;
		color: #f1f1f2;
	}

	.highlight {
		color: red;
	}

	.dialog_text {
		width: 45%;
		display: inline-block;
		height: 28px;
		//border: 1px solid #12837b;
	}

	.personal_center {
		min-width: 980px;
		flex-flow: column;
	}

	.personal_info {
		min-height: 500px;
		width: 70%;
		margin: 0 auto;
	}

	.DiFangZhiHeader {
		padding: 10px 0;
		width: 200px;
		/* text-align: center; */
		font-size: 14px;
		margin-top: 15px;
		margin-bottom: 15px;
	}

	.personalDetail {
		display: flex;
		margin-bottom: 20px;
	}

	.detailLeft {
		width: 250px;
		border: 1px solid #eaeaea;
		border-radius: 3px;
		font-size: 12px;
	}

	.userInfoCtx {
		margin-top: 25px;
	}

	.userImg {
		width: 50px;
		height: 50px;
		overflow: hidden;
		justify-content: center;
		align-items: center;
		display: inline-block;
		vertical-align: middle;
		border-radius: 50%;
		margin-left: 20px;
	}

	.uploadImg {
		width: 50px;
		height: 50px;
		overflow: hidden;
		justify-content: center;
		align-items: center;
		display: inline-block;
		vertical-align: middle;
		border-radius: 20%;
	}

	.downImg {
		width: 50px;
		height: 50px;
		overflow: hidden;
		justify-content: center;
		align-items: center;
		display: inline-block;
		vertical-align: middle;
		border-radius: 20%;
	}

	.userInfo {
		display: inline-block;
		vertical-align: middle;
		margin-left: 20px;
	}

	.userName {
		font-size: 14px;
		font-weight: bold;
		color: #17a2b8;
		margin-left: 5px;
	}

	span {
		text-align: left;
	}

	span {
		font-size: 12px;
		display: inline-block;
	}

	.personalAction {
		display: flex;
		justify-content: space-between;
		margin-top: 25px;
		margin-left: 15px;
		margin-right: 15px;
	}

	.action1 {
		margin-left: 15px;
	}

	.action3 {
		margin-right: 15px;
	}

	p {
		margin: 0 auto;
	}

	.line {
		width: 1px;
		background: #eaeaea;
	}

	.tabs {
		margin-top: 30px;
		min-height: 150px;
	}

	.links {
		padding: 30px 15px;
		background: #fafafa;
		height: 300px;
		overflow: auto;
	}

	.personalTab {
		text-align: center;
		padding: 10px 0;
		cursor: pointer;
	}

	.linksTitle {
		font-size: 16px;
	}

	.linkItem {
		padding-left: 20px;
		text-align: left;
		margin-top: 25px;
		color: #979797;
	}

	.detailRight {
		font-size: 12px;
		border: 1px solid #eaeaea;
		border-radius: 3px;
		margin-left: 10px;
		flex: 1;
		padding: 0 30px;
	}

	.userActionButton {
		display: flex;
		justify-content: space-between;
		padding: 10px 0;
		margin-top: 15px;
		margin-bottom: 15px;
	}

	.lunbobox {
		width: 200%;
		height: 85px;
		overflow: hidden;
		transition: all 1.5s;
		/* white-space:nowrap; */
	}

	.userActionItem {
		float: left;
		margin-right: 32px;
		cursor: pointer;
		display: flex;
		justify-content: center;
		align-items: center;
		width: calc(82px * 1.7);
		height: calc(50px * 1.7);
		font-size: 12px;
		color: #fff;
		border-radius: 5px;
	}

	.userActionText {
		padding-left: 5px;
		font-weight: bold;
		font-size: 12px;
		color: #fff;
	}

	.userActionText {
		padding-left: 5px;
		font-weight: bold;
	}

	.difangzhiUpload {
		background: #909cfb;
	}

	.cunqingLuru {
		background: #e49c2d;
	}

	.ziliaoshangchuan {
		background: #be7aff;
	}

	.jicengshangc {
		background: #39bd49;
	}

	.title {
		/* border-bottom: 0.1px solid #eaeaea; */
		margin-top: 10px;
		display: flex;
		justify-content: space-between;

		span:nth-child(1) {
			font-size: 14px;
		}

		span:nth-child(2) {
			color: #979797;
		}
	}

	.userImg {
		width: 40px;
		height: 40px;
		overflow: hidden;
		display: inline-block;
		border-radius: 50%;

		img {
			width: 20px;
			height: 20px;
			margin-top: 4px;
		}
	}

	.item {
		/* border-bottom: 0.1px solid #f0f0f0; */
		text-align: left;
		/* padding: 10px; */
		cursor: pointer;
	}

	.item:hover {
		/* border-bottom: 0.1px solid #f0f0f0; */
		text-align: left;
		/* padding: 10px; */
		cursor: pointer;
		background: #faf9f9;
	}

	.info {
		border-bottom: 2px solid #60abfa;
	}

	.more {
		cursor: pointer;
	}

	.DiFangZhiListHeader {
		color: rgba(255, 255, 255, 1);
		height: 180px;
		background-size: 100% 100%;
		background-position: center 0;
		background-size: cover;
	}

	.DiFangZhiListTop {
		display: flex;
		justify-content: space-between;
		padding-top: 55px;
		width: 1200px;
		margin: 0 auto;
		align-items: center;
	}

	.personFlag {
		font-size: 23px;
		display: inline-block;
		margin-left: 10px;
	}

	.Font_size {
		font-size: 16px;
	}

	.personal_info span:hover {
		cursor: pointer;
	}

	.loginout,
	.edit_info {
		cursor: pointer;
		font-size: 13px;
		color: #17a2b8;
		margin-top: 5px;
	}

	.loginout {
		margin-left: 10px;
	}

	.back {
		font-size: 14px;
		color: #409eff;
		cursor: pointer;
	}

	.down_dialog {
		width: 90%;
		margin: 0 auto;
	}

	.down_dialog .cell {
		height: 28px;
		line-height: 28px;
		width: 70%;
		box-shadow: 2px 2px 3px #efebeb;
		margin: auto;
		margin-top: 10px;
	}

	.down_dialog .cell .name {
		font-size: 12px;
		color: #12837b;
		margin-right: 5px;
	}

	.down_dialog .cell .value {
		color: #519b96;
		font-size: 13px;
		font-weight: bold;
	}

	.down_dialog p {
		color: #519b96;
		height: 28px;
		line-height: 28px;
		width: 70%;
		margin: 15px 15%;
		font-size: 13px;
		font-weight: bold;
		box-shadow: 2px 2px 3px #efebeb;
	}

	.down_dialog p span {
		font-size: 12px;
		color: #12837b;
		margin-right: 5px;
	}
</style>
